'use client';

import { memo, ReactNode, useMemo } from 'react';
import SVG from 'react-inlinesvg';

import { getImageSrc } from './util/getImageSrc';

interface SvgProps {
  width: number;
  height: number;
  color?: string; // color props 추가
  type?: 'svg' | 'icon' | 'lottie' | 'image' | 'public';
  src: string;
  preloadedSrc?: string;
  loader?: ReactNode;
  className?: string;
  onClick?: () => void;
  serviceName?: string;
}

function SvgComponent({ width, height, color, src, type, loader, preloadedSrc, className, onClick, serviceName = 'care', ...props }: SvgProps) {
  const resource = useMemo(() => {
    return preloadedSrc ? preloadedSrc : getImageSrc({ src, type: type ?? 'svg', serviceName });
  }, [preloadedSrc, src, type, serviceName]);

  return (
    <SVG
      src={resource}
      cacheRequests={true}
      width={width}
      height={height}
      loader={loader ? loader : <div className={`w-[${width}px] h-[${height}px]`} />}
      onError={(error) => console.log(error.message)}
      preProcessor={(code) => {
        if (color) {
          return code.replace(/fill=".*?"/g, `fill="${color}"`);
        }
        return code;
      }}
      onClick={onClick}
      className={className}
      uniqueHash="11f8d1"
      uniquifyIDs={true}
      {...props}
    />
  );
}

export const Svg = memo(SvgComponent);
